import React from "react";

function PaginatedProductPage() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Hello</h2>
    </div>
  );
}

export default PaginatedProductPage;
